import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionEyebrow } from './ui/SectionEyebrow';
export function ProblemSection() {
  return <section id="problem" className="py-24 bg-iris-black border-t border-iris-border relative overflow-hidden" data-id="element-235">
      <Container data-id="element-236">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-237">
          {/* Left: The Problem */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-238">
            <SectionEyebrow text="The Status Quo" className="mb-6" data-id="element-239" />
            <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6 leading-tight" data-id="element-240">
              SPREADSHEETS WEREN'T BUILT FOR INTELLIGENCE.
            </h2>
            <p className="text-iris-muted text-lg mb-8" data-id="element-241">
              Managing critical Requests for Information (RFIs) through email
              threads, shared folders, and static spreadsheets creates dangerous
              blind spots and operational friction.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-242">
              {['Untracked RFIs falling through the cracks', 'No immutable audit trail for compliance', 'Version control conflicts and lost data', 'Zero visibility into analyst performance or SLAs'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-243">
                  <AlertTriangleIcon className="w-5 h-5 text-red-500/80 shrink-0 mt-0.5" data-id="element-244" />
                  <span className="text-iris-text" data-id="element-245">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right: The Solution Visual */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="relative" data-id="element-246">
            <div className="absolute inset-0 bg-iris-green/5 blur-3xl rounded-full" data-id="element-247"></div>

            <div className="relative bg-iris-surface border border-iris-border p-6 rounded-sm shadow-2xl" data-id="element-248">
              <div className="flex items-center justify-between mb-6 border-b border-iris-border pb-4" data-id="element-249">
                <div className="flex items-center gap-2" data-id="element-250">
                  <div className="w-2 h-2 bg-iris-green rounded-full animate-pulse" data-id="element-251"></div>
                  <span className="font-mono text-sm text-white" data-id="element-252">
                    IRIS WORKFLOW ENGINE
                  </span>
                </div>
                <span className="font-mono text-xs text-iris-green bg-iris-green/10 px-2 py-1 rounded" data-id="element-253">
                  SECURE
                </span>
              </div>

              <div className="space-y-3" data-id="element-254">
                {[{
                id: 'RFI-2026-089',
                status: 'IN PROGRESS',
                title: 'Threat Assessment: Sector 4'
              }, {
                id: 'RFI-2026-090',
                status: 'ROUTED',
                title: 'Background Subject Inquiry'
              }, {
                id: 'RFI-2026-091',
                status: 'COMPLETED',
                title: 'Asset Verification Request'
              }].map((req, i) => <div key={i} className="bg-iris-black border border-iris-border p-4 flex items-center justify-between group hover:border-iris-green/50 transition-colors cursor-default" data-id="element-255">
                    <div className="flex items-center gap-4" data-id="element-256">
                      <CheckCircle2Icon className={`w-5 h-5 ${req.status === 'COMPLETED' ? 'text-iris-green' : 'text-iris-muted'}`} data-id="element-257" />
                      <div data-id="element-258">
                        <div className="font-mono text-xs text-iris-muted mb-1" data-id="element-259">
                          {req.id}
                        </div>
                        <div className="text-sm font-medium text-white" data-id="element-260">
                          {req.title}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4" data-id="element-261">
                      <span className={`text-xs font-mono px-2 py-1 ${req.status === 'COMPLETED' ? 'text-iris-green bg-iris-green/10' : req.status === 'IN PROGRESS' ? 'text-yellow-500 bg-yellow-500/10' : 'text-blue-400 bg-blue-400/10'}`} data-id="element-262">
                        {req.status}
                      </span>
                      <ArrowRightIcon className="w-4 h-4 text-iris-muted opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-263" />
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Decorative Redaction Bar */}
            <div className="absolute -bottom-4 -right-4 w-32 h-2 bg-iris-green" data-id="element-264"></div>
            <div className="absolute -bottom-4 -right-4 w-2 h-16 bg-iris-green" data-id="element-265"></div>
          </motion.div>
        </div>
      </Container>
    </section>;
}